// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"c13e90a8","787":"76f54053"}[chunkId] + ".chunk.js";
};